import { Box, Column, Columns, IconClear, Text } from 'braid-design-system';
import React from 'react';

import ButtonWrapper from 'src/components/ButtonWrapper/ButtonWrapper';

interface Props {
  itemLabel: string;
  remove: () => void;
}

const ListItem = ({ itemLabel, remove }: Props) => (
  <Columns align="left" space="none" collapseBelow="tablet">
    <Column width="1/3">
      <Box display="flex" justifyContent="spaceBetween">
        <Box
          width="full"
          overflow="hidden"
          paddingY="xxsmall"
          paddingRight="small"
          data-testid={itemLabel}
        >
          <Text maxLines={1}>{itemLabel}</Text>
        </Box>
        <ButtonWrapper onClick={remove}>
          <Box paddingY="xxsmall" data-testid={`clear-${itemLabel}`}>
            <Text>
              <IconClear />
            </Text>
          </Box>
        </ButtonWrapper>
      </Box>
    </Column>
  </Columns>
);

export default ListItem;
